import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "antd";
import AppHeader from "./components/AppHeader.tsx";
import LoginPage from "./pages/LoginPage.tsx";
import WorkerOrdersPage from "./pages/WorkerOrdersPage.tsx";
import RequireAuth from "./routes/RequireAuth.tsx";
import ThemeProvider from "./routes/ThemeProvider.tsx"; // ⬅️ default импорт

export default function App() {
  return (
    <ThemeProvider>
      <Layout style={{ minHeight: "100vh" }}>
        <AppHeader />
        <Layout.Content
          style={{ minHeight: "calc(100vh - 64px)", background: "var(--wo-bg)" }}
        >
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/worker/orders"
              element={
                <RequireAuth>
                  <WorkerOrdersPage />
                </RequireAuth>
              }
            />
            <Route path="/" element={<Navigate to="/worker/orders" replace />} />
            <Route path="*" element={<Navigate to="/worker/orders" replace />} />
          </Routes>
        </Layout.Content>
      </Layout>
    </ThemeProvider>
  );
}
